export default __webpack_public_path__ + "static/media/VELO.b5a402c0.svg";